export default __webpack_public_path__ + "static/pc-carousel-06-24b8843b812f03bdec2e81db0e956476.jpg";